import { FormTagInputComponent } from 'src/features/generalForms/builder/types/TagInput';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { useCallback } from 'react';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';

export const FormTagInput: FormTagInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const renderValue = useCallback((arr: string[]) => arr.join(', ') ?? '', []);

  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <></>;
  }

  return <AnswerPreviewRow<string[]> value={value} renderValue={renderValue} {...props} />;
};
